import styles from './style.module.scss'

export default function DotsLoader () {
  return <div className={styles.loader}></div>
}
